var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0333 14.0834C33.2833 6.38341 26.5667 2.91675 20.6667 2.91675C20.6667 2.91675 20.6667 2.91675 20.65 2.91675C14.7667 2.91675 8.03333 6.36675 6.28333 14.0667C4.33333 22.6667 9.6 29.9501 14.3667 34.5334C16.1333 36.2334 18.4 37.0834 20.6667 37.0834C22.9333 37.0834 25.2 36.2334 26.95 34.5334C31.7167 29.9501 36.9833 22.6834 35.0333 14.0834ZM20.6667 22.4334C17.7667 22.4334 15.4167 20.0834 15.4167 17.1834C15.4167 14.2834 17.7667 11.9334 20.6667 11.9334C23.5667 11.9334 25.9167 14.2834 25.9167 17.1834C25.9167 20.0834 23.5667 22.4334 20.6667 22.4334Z",
    fill: "url(#paint0_linear_133_105)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_105",
    x1: 20.6583,
    y1: 2.91675,
    x2: 20.6583,
    y2: 37.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BE2B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B87F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.651ef85fdbd8004dee5611f49a412250.svg";
export { ForwardRef as ReactComponent };